import { Component } from '@angular/core';
import { BaseListCombinedService } from '../../../../../@core/services/base-list-combined.service';
import { PostalAddress } from '../../../../../generated/generated-types';
import { BaseListWrapperComponent } from '../../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../../shared/components/new-base-list-component/new-base-list-component";
import { PostalAddressService } from '../../../services/postal-address.service';

@Component({
  selector: 'app-widget-postal-address-list',
  templateUrl: './widget-postal-address-list.component.html',
  standalone: true,
  imports: [
    BaseListWrapperComponent
  ]
})
export class WidgetPostalAddressListComponent extends NewBaseListComponent<PostalAddress> {

  //this is for free Addresses

  // @Input()
  // addressId: string;

  constructor(postalAddressServce: PostalAddressService,
    private baseListServices: BaseListCombinedService) {

    super("PostalAddress", postalAddressServce);
    // this.applyClick = this.applyClick.bind(this);

    // this.data = resourceService;
  }

  // async ngOnChanges(c) {

  //   if (c.addressId) {
  //     this.buildFilter();
  //     this.refresh();
  //   }

  // }
  // buildFilter() {

  //   this.postalAddressServce.applySearchRule(this.currentSearchInput, {
  //     field: "addressId",
  //     operator: Operator.equal,
  //     value: this.addressId
  //   });
  // }

}
